import { mapActions } from "vuex";

export default {
  methods: {
    ...mapActions("admin", ["deleteAdmin", "admindeactive"]),
  },
};
